// extracted by mini-css-extract-plugin
module.exports = {"kitK":"kitK_kitK__8QKQf"};